// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"47717fb6","736":"7e9a2285"}[chunkId] + ".chunk.css";
};